import { adminPartnerQueryKeys as e } from "./useAdminPartnerQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminPartnersApi as n } from "@maat/api-main";
//#region src/partners/admin/useAdminPartnerTimeseriesQuery.ts
var r = (r, i) => t({
	queryKey: e.timeseries(r, i),
	queryFn: () => n.timeseries(r, i),
	enabled: !!r
});
//#endregion
export { r as useAdminPartnerTimeseriesQuery };
